import { Dispatch } from "redux";
import { appSetSnackbar, NO_SNACKBAR_ID } from "jadro-pico-app/Redux/AppCoreReducer";
import type { RetryAction } from "../ErrorState/ErrorStateTypes";

export const SNACKBAR_TIMEOUT_MS = 3000;

let activeOnClick: (() => void) | null = null;
let nextSnackbarId = NO_SNACKBAR_ID;
const lastShownByText = new Map<string, number>();

const DEDUP_WINDOW_MS = SNACKBAR_TIMEOUT_MS;

export function showSnackbar(dispatch: Dispatch, text: string, action?: RetryAction): void {
  const now = Date.now();
  const lastShown = lastShownByText.get(text) ?? 0;
  if (now - lastShown < DEDUP_WINDOW_MS) return;
  lastShownByText.set(text, now);

  activeOnClick = action?.onClick ?? null;
  nextSnackbarId += 1;
  dispatch(appSetSnackbar({ text, actionLabel: action?.label ?? null, id: nextSnackbarId }));
}

export function consumeSnackbarAction(): void {
  const cb = activeOnClick;
  activeOnClick = null;
  cb?.();
}

export function clearSnackbarAction(): void {
  activeOnClick = null;
}
